import { Box, Radio, RadioProps, Typography, useTheme } from '@mui/material';
import { useId } from 'react';

import { RadioBoxCheckedIcon, RadioBoxUncheckedIcon } from '@/icons';

type RadioBoxButtonProps = RadioProps & {
  label: string;
  checked: boolean;
  onChange: () => void;
  children?: React.ReactNode;
};

export const RadioBoxButton = ({
  label,
  checked,
  onChange,
  children,
  ...props
}: RadioBoxButtonProps) => {
  const { palette } = useTheme();
  const id = useId();

  return (
    <Box
      sx={{
        borderRadius: 2,
        width: '100%',
        height: 44,
        background: checked ? palette.gradients.primary2 : palette.grey50,
        color: checked ? 'text.contrast' : 'text.main',
        display: 'flex',
        alignItems: 'center',
        cursor: props.disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={onChange}>
      <Radio
        disableRipple
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
        color="default"
        icon={<RadioBoxUncheckedIcon sx={styles.icon} />}
        checkedIcon={<RadioBoxCheckedIcon sx={styles.icon} />}
        checked={checked}
        onChange={onChange}
        id={`radio-input-${id}`}
        {...props}
      />
      {children}
      <Typography
        variant="body2"
        component="label"
        htmlFor={`radio-input-${id}`}
        sx={{
          pointerEvents: 'none',
          color: checked ? 'text.contrast' : 'text.main',
        }}>
        {label}
      </Typography>
    </Box>
  );
};

const styles = {
  icon: {
    width: 20,
    height: 20,
    color: 'text.main',
  },
};
